import React, { useCallback, useEffect } from "react";
import { initRequest } from "../../shared/common/learnosityAuthorInit";
import { getRequest } from "../../../api/user.service";

export default function LearnosityQuestionEditor(props: any) {
  let authorApp;

  interface QuestionData {
    stimulus: string;
    multiple_responses: boolean;
  }
  const questionsData: QuestionData[] = [];

  function initializeQuestionData(questions) {
    questions.forEach((question) => {
      questionsData.push({
        stimulus: question.data.stimulus,
        multiple_responses: question.data.multiple_responses
          ? question.data.multiple_responses
          : false,
      });
    });
  }

  function automaticUpdateScoring(props, widget) {
    const questionData = questionsData.find(
      (item) => item.stimulus === widget.stimulus
    );
    if (questionData) {
      if (
        widget.multiple_responses &&
        questionData.multiple_responses === false
      ) {
        widget.validation.scoring_type = "partialMatchV2";
        widget.validation.valid_response.score = 2;
        widget.validation.rounding = "none";
        questionData.multiple_responses = true;
        authorApp.setWidget(widget, props.payloadLabel);
      }

      if (!widget.multiple_responses) {
        questionData.multiple_responses = false;
      }
    }
  }

  const initialization = useCallback(async () => {
    const callbacks = {
      readyListener: await async function () {
        await authorApp.on("render:item", async function () {
          props.authorAppParent(authorApp);
          const questions = authorApp.getItem().questions;
          if (props.questionTypeId == 1 || props.questionTypeId == 3) {
            initializeQuestionData(questions);
          }
          if (questions.length == 0) {
            if (
              props.englishWidgetDataArray.length == 0 ||
              !props.englishWidgetDataArray[props.addQuestionIndex] ||
              props.isSubTypeChanged
            ) {
              const questionData = props.payload;
              await authorApp.setWidget(questionData, props.payloadLabel);
              if (props.englishWidgetDataArray[props.addQuestionIndex]) {
                props.englishWidgetDataArray[props.addQuestionIndex] =
                  questionData;
                props.setEnglishWidgetDataArray(props.englishWidgetDataArray);
              } else {
                props.englishWidgetDataArray.push(questionData);
                props.setEnglishWidgetDataArray([
                  ...props.englishWidgetDataArray,
                ]);
              }
            } else {
              const questionData =
                props.englishWidgetDataArray[props.addQuestionIndex];

              authorApp.setWidget(questionData, props.payloadLabel);
            }
          } else {
            if (props.isSubTypeChanged) {
              const questionData = props.payload;
              await authorApp.setWidget(questionData, props.payloadLabel);
              if (props.englishWidgetDataArray[props.addQuestionIndex]) {
                props.englishWidgetDataArray[props.addQuestionIndex] =
                  questionData;
                props.setEnglishWidgetDataArray(props.englishWidgetDataArray);
              } else {
                props.englishWidgetDataArray.push(questionData);
                props.setEnglishWidgetDataArray([
                  ...props.englishWidgetDataArray,
                ]);
              }
            } else {
              if (
                questions[props.addQuestionIndex] &&
                !props.englishWidgetDataArray[props.addQuestionIndex]
              ) {
                const itemRef = authorApp.getItem().item.reference;
                const widgetRef = questions[props.addQuestionIndex].reference;

                props.englishWidgetDataArray[props.addQuestionIndex] =
                  questions[props.addQuestionIndex].data;

                props.setLoading(false);
                return authorApp.navigate(
                  "items/" + itemRef + "/widgets/" + widgetRef + ""
                );
              } else if (
                !props.englishWidgetDataArray[props.addQuestionIndex] &&
                !questions[props.addQuestionIndex]
              ) {
                const questionData = props.payload;
                await authorApp.setWidget(questionData, props.payloadLabel);
                props.englishWidgetDataArray.push(questionData);
                props.setEnglishWidgetDataArray([
                  ...props.englishWidgetDataArray,
                ]);
              } else if (props.englishWidgetDataArray[props.addQuestionIndex]) {
                const questionData =
                  props.englishWidgetDataArray[props.addQuestionIndex];
                authorApp.setWidget(questionData, props.payloadLabel);
              }
            }
          }
          props.setLoading(false);
          setTimeout(function () {
            props?.disablePenaltyPoints();
          }, 1000);
        });
        authorApp.on("widgetedit:preview:changed", function (event) {
          const widget = authorApp.getWidget();
          if (props.englishWidgetDataArray[props.addQuestionIndex]) {
            props.englishWidgetDataArray[props.addQuestionIndex] = widget;
            props.setEnglishWidgetDataArray(props.englishWidgetDataArray);
          } else {
            props.englishWidgetDataArray.push(widget);
            props.setEnglishWidgetDataArray([...props.englishWidgetDataArray]);
          }
          if (props.questionTypeId == 1 || props.questionTypeId == 3) {
            automaticUpdateScoring(props, widget);
          }
          props.setWidgetEN(widget);
          setTimeout(function () {
            props?.disablePenaltyPoints();
          }, 1000);
        });
      },
    };
    props.setLoading(true);
    const request = initRequest(props.itemRef.toString(), "questions");
    getRequest("author", JSON.stringify(request)).then(async (response) => {
      if (response.data && document.getElementById("learnosity-author")) {
        authorApp = await window["LearnosityAuthor"]?.init(
          response.data,
          callbacks
        );
      }
    });
  }, [props.addQuestionIndex]);

  useEffect(() => {
    initialization();
  }, [initialization]);

  return (
    <div>
      <div className="main-content-0">
        <label>Question 1</label>
        <div id="learnosity-author"></div>
      </div>
      {props.arr.map((element: number, index) => {
        return (
          <div key={index} className={"main-content-" + element}>
            <label>Question {element + 1}</label>
            <div id="learnosity-author"></div>
          </div>
        );
      })}
    </div>
  );
}
